import React from "react";
import { GenericDropdownItem } from "@sonder/ui/source/styled/fragments/GenericDropdownItem";
import { UserCardInDropdownItem } from "@sonder/ui/source/styled/fragments/UserCardInDropdownItem";
import { useStore as useAuthStore } from "auth/store";
import { useErrorReporterFiltered } from "core/hooks/useErrorReporterFiltered";
import { useManageUser } from "core/queries/ManageUser";
import { UserData } from "core/queries/SearchForUsers";
import { UndoAction, addUndo } from "team/actions";
import { useStore as useTeamStore } from "team/store";

interface AddMemberGroupItemProps {
  closePortal(): void;
  user: UserData;
}

export const AddMemberGroupItem = ({
  closePortal,
  user,
}: AddMemberGroupItemProps) => {
  const { email, id: userId } = user;
  const avatarUrl = user.avatar?.url;
  const userCity = user.tomTeamMember?.city;
  const userName = user.name || undefined;

  const { state: authState } = useAuthStore();
  const cityId = authState.user?.cityId;

  const errorReporter = useErrorReporterFiltered();
  const { dispatch } = useTeamStore();
  const [addUser, { loading }] = useManageUser({
    awaitRefetchQueries: true,
    refetchQueries: ["GetTeam"],
    variables: {
      userId,
      cityId,
    },
  });

  if (!cityId) return null;

  const onClick = () => {
    if (loading || userCity) return;

    closePortal();

    addUser()
      .then(response => {
        const mutatedUser = response.data?.manageUser?.user;
        if (mutatedUser) dispatch(addUndo(UndoAction.ADD_MEMBER, mutatedUser));
      })
      .catch(error => {
        errorReporter.notify(error);
      });
  };

  const title = userCity
    ? `User is already part of the ${userCity.name} team.`
    : undefined;
  return (
    <GenericDropdownItem disabled={!!userCity} title={title} onClick={onClick}>
      <UserCardInDropdownItem
        email={email}
        imageUrl={avatarUrl}
        name={userName}
      />
    </GenericDropdownItem>
  );
};
